import React, { useEffect, useState } from "react";
import { Radio, Users, Globe2, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

function fmt(n) {
  if (n == null) return "—";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + "k";
  return String(n);
}

export default function SocialProof() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/stats/public");
        if (!cancelled) setStats(data);
      } catch (_) {}
    };
    load();
    const t = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const items = [
    { icon: Radio, label: "Stations live", value: fmt(stats?.stations_live) },
    { icon: Users, label: "Broadcasters", value: fmt(stats?.broadcasters_total) },
    { icon: Globe2, label: "Countries on air", value: fmt(stats?.countries_covered) },
    { icon: TrendingUp, label: "Listener-min · 7d", value: fmt(stats?.listener_minutes_7d) },
  ];

  return (
    <section className="max-w-7xl mx-auto px-5 mt-16" data-testid="social-proof">
      <div className="flex items-center justify-center gap-2 mb-5">
        <span className="live-dot" />
        <span className="fl-mono text-[10px] tracking-[0.3em] uppercase text-emerald-500">// On air right now</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5">
        {items.map(({ icon: Icon, label, value }) => (
          <div key={label} className="fl-card p-4 sm:p-5 flex items-center gap-3 sm:gap-4" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="w-10 h-10 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-emerald-500" />
            </div>
            <div className="min-w-0">
              <div className="fl-display text-2xl sm:text-3xl font-extrabold tracking-tighter leading-none">{value}</div>
              <div className="fl-mono text-[10px] tracking-widest uppercase text-slate-400 mt-1 truncate">{label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
